import { get, post } from '@/request/request';

export default {
  list(params) {
    return get('/admin/doc/receipt/list', params);
  },
  info(params) {
    return get('/admin/doc/receipt/info', params);
  },
  save(params) {
    return post('/admin/doc/receipt/save', params);
  },
  delete(params) {
    return post('/admin/doc/receipt/delete', params);
  }
};
